import { makeAutoObservable } from "mobx";
import type { CarouselModel } from "src/models/carousel";
import type { FAQModel } from "src/models/faq";
import type { PartnerModel } from "src/models/partner";
import type { ServiceModel } from "src/models/service";
import type { TestimonialModel } from "src/models/testimonial";
import { getAllHomeData, getBanners, getFaqs, getPartners, getServices, getTestimonials } from "src/services/home/homeService";

export class HomeStore {
  
  banners: CarouselModel[] = [];

  services: ServiceModel[] = [];

  faqs: FAQModel[] = [];

  partners: PartnerModel[] = [];

  testimonials: TestimonialModel[] = [];


  constructor() {
    makeAutoObservable(this);
    this.intialize();
  }

  async intialize(){
    getBanners(true, true,true).then(({data}) => this.banners = data);
    getServices().then(({data}) => this.services = data);
    getTestimonials(true, true).then(({data}) => this.testimonials = data);
    getPartners().then(({data}) => this.partners = data);
    getFaqs(true, true).then(({data}) => this.faqs = data);
  }

  
}